import React from "react";
import ReactDOM from "react-dom";
import Mark from "mark.js";
import { compact, trim } from "lodash";

type Props = {
  children?: React.ReactNode;
  highlightSearch?: string[] | string;
  getMarkjsContext?: () => HTMLElement | HTMLElement[] | NodeList;
};

export class MarkHighlighter extends React.PureComponent<Props> {
  prevInstance: Mark;

  componentDidMount() {
    this.markSearchText();
  }

  componentDidUpdate() {
    this.markSearchText();
  }

  markSearchText() {
    const { highlightSearch } = this.props;

    if (!highlightSearch) {
      return;
    }

    const search =
      typeof highlightSearch === "string"
        ? compact([trim(highlightSearch)])
        : compact(highlightSearch.map((x) => trim(x)));

    if (this.prevInstance) {
      this.prevInstance.unmark();
    }

    if (!Array.isArray(search) || search.length === 0) {
      return;
    }

    const ctx = this.getContext();

    if (ctx) {
      const instance = new Mark(ctx);
      instance.mark(search);
      this.prevInstance = instance;
    }
  }

  getContext() {
    if (this.props.getMarkjsContext) {
      return this.props.getMarkjsContext();
    }

    const card = ReactDOM.findDOMNode(this);

    if (card instanceof HTMLElement) {
      return card.querySelectorAll(".highlighter");
    }
  }

  render() {
    return <div>{this.renderElement()}</div>;
  }

  renderElement() {
    const { children } = this.props;
    return children;
  }
}

export default MarkHighlighter;
